import _ from 'underscore';
import { Module } from 'vuex';
import { RootState } from '@/types';
import UserProfile from '@/classes/UserProfile';

export interface UserState {
  users: UserProfile[];
}

export const UserStore: Module<UserState, RootState> = {
  namespaced: true,

  state: {
    users: []
  },

  getters: {
    getFieldCoordinators: (state) => (): UserProfile[] =>
      _(state.users)
        .chain()
        .filter((u) => u.securityLevel === 'FIELD_COORDINATOR')
        .sortBy((u) => u.firstName)
        .sortBy((u) => u.lastName)
        .value(),

    getUserProfileById:
      (state) =>
      (id: number): UserProfile | undefined =>
        _(state.users).find((u) => u.id === id)
  },

  mutations: {
    setUserProfiles(state, users: UserProfile[]) {
      state.users = users;
    }
  },

  actions: {}
};
